import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { closeModal } from '../../../../../store/modals';
import { IStateType } from '../../../../../store/models/root.interface';
import CancelConfigurationFormModal, { DispatchPropsType, BaseSeeMorePropsType } from '../../organisms/receiveMessage/cancelConfigurationFormModal';


const mapStateToProps = (state: IStateType) => ({
    visible: state.modals.isOpen,
})

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeModal()),
})

export default connect<BaseSeeMorePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(CancelConfigurationFormModal));
